
<script>
 
import router from "../router";
 
 import i18n from '@/i18n';
export default {
  name: "LogoutSession",
  mounted(){
    this.$store.dispatch('login', {});
    window.localStorage.removeItem('user');
    const l = i18n.global.locale.value;
    const url= l ==='es' ?  "/es" : "/";
      router.push(url);
  }, 
};
</script>
